import { render, staticRenderFns } from "./asc.vue?vue&type=template&id=12da1454&scoped=true&"
import script from "./asc.vue?vue&type=script&lang=js&"
export * from "./asc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12da1454",
  null
  
)

export default component.exports